import React, { useContext, useState } from 'react'
import { Drawer } from 'antd';
import Logo from "../../Assets/Images/logo.png"
import { Link } from 'react-router-dom'
import PhoneEnabledIcon from '@mui/icons-material/PhoneEnabled';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { HashLink } from 'react-router-hash-link';
import { Context } from '../../Context/LangContext';
function FixedHeader() {
  const { lang } = useContext(Context)
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);

  };
  const [changeBack, setChangeBack] = useState(false)
  const changeBacground = () => {
    if (window.scrollY !== 0) {
      setChangeBack(true)
    }
    else {
      setChangeBack(false)
    }
  }
  window.addEventListener("scroll", changeBacground)
  return (
    <div className={`py-[10px] z-50 xl:px-0 top-0 fixed w-full ${changeBack ? "bg-[#4633AF] md:py-[10px]" : " md:py-[20px] "}`}>

      <div className='xl:container mx-auto px-5 flex items-center justify-between'>
        <Link to={'/'}>
          <img src={Logo} alt='Logo' width={170} height={50} />
        </Link>
        <nav className='hidden lg:flex items-center'>
          <HashLink
            smooth
            to="/#main"
            className='text-white cursor-pointer px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]'>{lang ? "BOSH SAHIFA" : "Главная"} </HashLink>

          <HashLink
            smooth
            to="/#function"
            className='text-white cursor-pointer px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]'>{lang ? "FUNKSIYALAR" : "ФУНКЦИИ"} </HashLink>

          <HashLink
            smooth
            to="/#preview"
            className='text-white cursor-pointer px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]'>
            {lang ? "KO'RISH" : "ПРЕВЬЮ"}
          </HashLink>
          <HashLink
            smooth
            to="/#contact"
            className='text-white cursor-pointer px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]'>
            {lang ? "ALOQALAR" : "КОНТАКТЫ"}
          </HashLink>
          <Link className='text-white px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]' to={'/branchs'}>
            {lang ? "FILIALLAR" : "ФИЛИAЛ"}
          </Link>
          <HashLink
            smooth
            to="/services"
            className='text-white cursor-pointer px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]'>
            {lang ? "NARXLAR VA XIZMATLAR" : "ТАРИФЫ И УСЛУГИ"}
          </HashLink>
          <HashLink
            smooth
            to="/user-agreement"
            className='text-white cursor-pointer px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]'>
            {lang ? "OMMAVIY OFERTA" : "ПУБЛИЧНАЯ ОФЕРТА"}
          </HashLink>
          <HashLink
            smooth
            to="/manual"
            className='text-white uppercase cursor-pointer px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]'>
            {lang ? "Foydalanuvchi uchun qo'llanma" : "Руководство пользования"}
          </HashLink>
          <a className='text-white  px-3 py-2 font-semibold  text-[14px] flex items-center space-x-2' href={'tel:712009096'}>
            <button className='w-[29px] duration-200 h-[29px] hover:bg-white hover:text-[#00C9DB] bg-[#00C9DB] rounded-[50%]'><PhoneEnabledIcon className='w-[15px]' /></button>
            <span className='hover:text-[#00C9DB] duration-200' >71 200-90-96</span>
          </a>
        </nav>
        <button onClick={showDrawer} className={`relative duration-200 w-[25px] flex flex-col space-y-1  lg:hidden text-white `}>
          <span className={`w-full h-[3px] rounded-lg bg-white `}></span>
          <span className={`w-full h-[2.5px] rounded-lg bg-white duration-200`}></span>
          <span className={`w-full duration-200 h-[2.8px] rounded-lg bg-white `}></span>
        </button>
      </div>
      <Drawer className='navbar-navigation' placement="right" onClose={onClose} open={open}>
        <div>
          <div className='flex mb-5 items-center justify-between'>
            <Link to={'/'}>
              <img src={Logo} alt='Logo' width={170} height={50} />
            </Link>
            <button onClick={onClose} className={`relative duration-200 w-[20px] flex flex-col space-y-2  lg:hidden text-white `}>
              <span className={`w-full rotate-[45deg] translate-y-[5px] h-[3px] rounded-lg bg-white `}></span>
              <span className={`w-full -rotate-[45deg] -translate-y-[6px] duration-200 h-[2.8px] rounded-lg bg-white `}></span>
            </button>
          </div>
          <nav className='flex justify-between'>
            <div className='flex flex-col'>
              <HashLink
                onClick={onClose}
                smooth
                to="/#main" className='text-white px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]'>{lang ? "BOSH SAHIFA" : "ГЛАВНЫЙ"} </HashLink>
              <HashLink
                onClick={onClose}
                smooth
                to="/#function" className='text-white px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]'>{lang ? "FUNKSIYALAR" : "ФУНКЦИИ"} </HashLink>
              <HashLink
                onClick={onClose}
                smooth
                to="/#preview" className='text-white px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]'>{lang ? "KO'RISH" : "ПРЕВЬЮ"} </HashLink>

              <HashLink
                onClick={onClose}
                smooth
                to="/#contact" className='text-white px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]'>{lang ? "ALOQALAR" : "КОНТАКТЫ"} </HashLink>
              <Link onClick={onClose} className='text-white px-3 py-2 hover:text-[#00C9DB] duration-200 font-semibold text-[14px]' to={'/branchs'}>{lang ? "FILIALLAR" : "ФИЛИAЛ"}</Link>
            </div>
            <div className='flex flex-col items-end'>
              <Link className='text-white  px-3 py-2 font-semibold  text-[14px] flex items-center space-x-2' to={'tel:712009096'}>
                <button className='w-[29px] duration-200 h-[29px] hover:bg-white hover:text-[#00C9DB] bg-[#00C9DB] rounded-[50%]'><PhoneEnabledIcon className='w-[15px]' /></button>
                <span className='hover:text-[#00C9DB] duration-200' >71 200-90-96</span>
              </Link>
              <div className='text-white flex flex-col items-end cursor-pointer relative px-3 font-semibold text-[14px] ' to={'/'}>
                <Link onClick={onClose} className='hover:text-[#00C9DB] py-2' to={'/services'}>{lang ? "NARXLAR VA XIZMATLAR" : "ТАРИФЫ И УСЛУГИ"}</Link>
                <Link onClick={onClose} className='  hover:text-[#00C9DB] py-2' to={'/user-agreement'}>{lang ? "OMMAVIY OFERTA" : "ПУБЛИЧНАЯ ОФЕРТА"}</Link>
                <Link onClick={onClose} className=' uppercase text-end hover:text-[#00C9DB] py-2' to={'/manual'}> {lang ? "Foydalanuvchi uchun qo'llanma" : "Руководство пользования"}</Link>
              </div>
            </div>

          </nav>
        </div>
      </Drawer>
    </div>
  )
}

export default FixedHeader